import { useEffect, useState } from 'react';
import { useBiometricLoginToggle } from '~/components/NavigationAndStructure/UserMenu/BiometricLogin/useBiometricLoginToggle';
import { useIoContext } from '~/contexts';
export const useBiometricNudge = ()=>{
    const { native } = useIoContext();
    const { available, checked, loading, method, onToggle } = useBiometricLoginToggle();
    const [dismissed, setDismissed] = useState(true);
    useEffect(()=>{
        if (!native.isNative) {
            return undefined;
        }
        let cancelled = false;
        const read = async ()=>{
            const { nudgeDismissed } = await native.biometric.getStatus();
            if (!cancelled) {
                setDismissed(nudgeDismissed);
            }
        };
        void read();
        return ()=>{
            cancelled = true;
        };
    }, [
        native.isNative
    ]);
    const shouldShow = available && !dismissed && (!checked || loading);
    const dismiss = async ()=>{
        setDismissed(true);
        await native.biometric.dismissNudge();
    };
    const enroll = ()=>void onToggle(true);
    return {
        shouldShow,
        method,
        loading,
        enroll,
        dismiss
    };
};
